import React, { useState } from "react";
import { Send, X } from "lucide-react";

export default function CommonPanel({
  open,
  onClose,
  title,
  placeholder,
  data,
  addItem,
  theme = "blue",
}) {
  const [text, setText] = useState("");

  if (!open) return null;

  const themeStyles = {
    blue: {
      border: "#bfdbfe",
      bg: "#eff6ff",
      btn: "#3b82f6",
      heading: "#1e40af",
    },

    purple: {
      border: "#e9d5ff",
      bg: "#faf5ff",
      btn: "#a855f7",
      heading: "#6b21a8",
    },

    red: {
      border: "#fecaca",
      bg: "#fff1f2",
      btn: "#ef4444",
      heading: "#991b1b",
    },
  };

  const colors = themeStyles[theme];

  return (
    <div className={`commonPanel commonPanel--${theme}`}>
      <div className="commonPanel__header">
        <h3 className="commonPanel__title">{title}</h3>

        <X size={18} onClick={onClose} className="commonPanel__close" />
      </div>

      <div className="commonPanel__inputRow">
        <input
          placeholder={placeholder}
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="commonPanel__input"
        />

        <button
          onClick={() => {
            if (!text.trim()) return;

            addItem({
              user: "Current User",
              text,
              date: new Date().toLocaleString(),
            });

            setText("");
          }}
          className="commonPanel__sendBtn"
        >
          <Send size={16} color="#fff" />
        </button>
      </div>

      <div className="commonPanel__list">
        {data.map((c, i) => (
          <div className="commonPanel__item">
            <div className="commonPanel__avatar">
              {c.user.slice(0, 2).toUpperCase()}
            </div>

            <div>
              <div className="commonPanel__name">{c.user}</div>

              <div className="commonPanel__text">{c.text}</div>

              <div className="commonPanel__date">{c.date}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
